import React from 'react';
import { observer } from 'mobx-react';
import { Button, Grid } from '@mui/material';
import { useTranslation } from '@gamiphy/react-i18n';
import { IntegrationsStore } from '@gamiphy/loyalty-station-desktop/store/integrations';
import { SdkStore } from '@gamiphy/loyalty-station-desktop/store/sdk';

type Props = {
  setCheckLater: (arg: boolean) => void,
}

const SignIn: React.FC<Props> = observer(({ setCheckLater }) => {
  const { t } = useTranslation();

  return (
    <Grid container justifyContent="center" alignItems="center" sx={{ mt: 1 }}>
      <Grid container size={12} justifyContent="center">
        <Button
          sx={{
            textDecoration: 'underline',
            width: 'fit-content',
            fontSize: '16px',
            fontWeight: 600,
            color: 'text.primary',
            py: 1,
            '&:hover': {
              cursor: 'pointer',
              textDecoration: 'underline',
            },
          }}
          onClick={() => {
            void SdkStore.goToAuth(false);
            void IntegrationsStore.trackGTMEvent({
              category: 'welcomeCoupon',
              action: 'signinClicked',
            });
          }}
        >
          {t('draft.user.signIn', 'Sign-In')}
        </Button>
      </Grid>
      <Grid size={12} container justifyContent="center" sx={{ textAlign: 'center' }}>
        <Button
          sx={{
            width: 'fit-content',
            fontSize: '12px',
            color: 'text.primary',
            py: 1,
            '&:hover': {
              cursor: 'pointer',
            },
          }}
          onClick={() => {
            void IntegrationsStore.trackGTMEvent({
              category: 'welcomeCoupon',
              action: 'checklaterClicked',
            });
            setCheckLater(true);
          }}
        >
          {t('draft.user.checkLater', 'Check later')}
        </Button>
      </Grid>
    </Grid>
  );
});

export default SignIn;
